export default "__VITE_PUBLIC_ASSET__ec786241__"